import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  planSummaryTitle: {
    defaultMessage: 'Plan Summary',
    description: 'Title text for the plan summary area in the plan subscription update drawer',
    id: 'z24tVs',
  },
  updatePlanButtonText: {
    defaultMessage: 'Update Plan',
    description: 'Text for the action button in the plan summary that a user clicks to finalize their plan selection',
    id: '7pF1pB',
  },
  monthlyTotal: {
    defaultMessage: 'Monthly Total',
    description: 'Text informing the user overall price for all subscription changes',
    id: 'tSbJi5',
  },
  yearlyTotal: {
    defaultMessage: 'Yearly Total',
    id: 'HmRnIG',
    description: 'Text informing the user overall price for all subscription changes on annual billing',
  },
  yourCarriersTitle: {
    defaultMessage: 'Your Carriers: {value}',
    description: 'Title of the Your Carriers feature',
    id: '6qS4on',
  },
  yourCarriersExplanation: {
    defaultMessage: 'Add as many of your own carriers as you like.',
    description: 'Text describing the Your Carriers feature',
    id: 'EDSmGa',
  },
  addOnNameInTrial: {
    defaultMessage: '{addonName} (Trial)',
    id: 'ReOiQ1',
    description: 'Label for the name of a given add on in trial',
  },
  addOnTrialDisclaimer: {
    defaultMessage: 'You will be charged {price}/mo for this add-on after {paymentDate}',
    id: 'Z1NnM2',
    description: 'Disclaimer for when a trial add-on will be converted to a paid add-on',
  },
  addOnTrialDisabledAfterTrial: {
    defaultMessage: 'Choose a plan to continue using this add-on after {paymentDate}',
    id: 'Ef7WDW',
    description: 'Disclaimer for when a trial add-on will be disabled because no billing plan is selected',
  },
  addonsTitle: {
    defaultMessage: 'Add-Ons',
    description: 'Section title for add on price breakdown',
    id: 'ekXWWe',
  },
  addonsPriceLabel: {
    defaultMessage: '{addonName} add-on cost',
    id: 'vbLUps',
    description: 'Label for the total cost of a given add on',
  },
  active: {
    defaultMessage: 'Active',
    description: 'active feature label',
    id: '2ghPCF',
  },
  inactive: {
    defaultMessage: 'Inactive',
    description: 'inactive feature label',
    id: '4/Zg7E',
  },
  shipmentsPerMonth: {
    defaultMessage: 'Shipments / mo: {value}',
    description: 'Text informing the user of how many shipments per month their plan allows for.',
    id: 'qDdytn',
  },
  usersInPlan: {
    defaultMessage: 'Users: {value} included',
    description: 'Text informing the user of how many shipments per month their plan allows for.',
    id: 'GsfCdR',
  },
  additionalUsers: {
    defaultMessage: 'Additional users: {value}',
    description: 'Text informing the user of how many additional users they wish to add.',
    id: 'rjtkUl',
  },
  additionalUsersTotalPrice: {
    defaultMessage: 'Total Additional User Seats Price',
    description: 'Text informing the user overall price for additional user changes',
    id: 'daMctb',
  },
  includedUsers: {
    defaultMessage: 'Included in plan: {value}',
    description: 'Text informing the user of how many users their desired plan includes.',
    id: 'XgSIZg',
  },
  users: {
    defaultMessage: 'Users ({value})',
    description: 'Text informing the user of how many users included in their desired plan plus any additional users they wish to add.',
    id: 'tUoqer',
  },
  analyticsLicenses: {
    defaultMessage: 'Analytics Licenses ({value})',
    description: 'Text informing the user of how many analytics licenses included in their plan plus any additional licenses.',
    id: 'MqYy/c',
  },
  includedAnalyticsLicenses: {
    defaultMessage: 'Included in plan: {value}',
    description: 'Text informing the user of how many analytics licenses their desired plan includes.',
    id: 'aoKuAN',
  },
  additionalAnalyticsLicenses: {
    defaultMessage: 'Additional licenses: {value}',
    description: 'Text informing the user of how many additional analytics licenses they wish to add.',
    id: 'FLgz3S',
  },
  additionalAnalyticsLicensesTotalPrice: {
    defaultMessage: 'Total Additional Analytics Licenses Price',
    description: 'Text informing the user overall price for additional analytics license changes',
    id: 'KtmUY7',
  },
  none: {
    defaultMessage: 'None',
    id: 'SIzMPx',
    description: 'label to indicate when no add-ons are being included/purchased for this plan',
  },
  volumeTitle: {
    defaultMessage: 'Volume',
    description: 'Title for the volume section in the plan summary',
    id: '+o736I',
  },
  planTitle: {
    defaultMessage: 'Plan',
    description: 'Title for the plan section in the plan summary',
    id: 'QnK9AM',
  },
  unlimited: {
    defaultMessage: 'Unlimited',
    description: 'An unlimited number of things',
    id: '+9N6II',
  },
  discountTitle: {
    defaultMessage: 'Discount',
    description: 'Title for the discount section in the plan summary',
    id: 'H5Us5b',
  },
  subscriptionSavings: {
    defaultMessage: 'Subscription Savings: {percent}',
    description: 'Text describing the discount percentage being applied to the subscription',
    id: '9aease',
  },
  selectPaymentMethodPlaceholder: {
    id: '8DqB6t',
    defaultMessage: 'Select a payment method',
    description: 'Placeholder text for the payment method selection dropdown',
  },
  addPaymentMethod: {
    id: 'Q1r4/C',
    defaultMessage: 'Add Payment Method',
    description: 'Button text shown when no payment methods exist, prompting the user to add one',
  },
  noPaymentMethodsAvailable: {
    id: 'pwbUm9',
    defaultMessage: 'No payment methods available',
    description: 'Message shown when no payment methods are available to select',
  },
  getPaymentMethodsErrorTitle: {
    description: 'Title for error when fetching payment methods',
    defaultMessage: 'Error fetching payment methods',
    id: 'gdZM2h',
  },
  getPaymentMethodsErrorContent: {
    description: 'Content for error when fetching payment methods',
    defaultMessage: 'There was an error fetching your payment methods. Please try again later.',
    id: 'dtIakQ',
  },
  taxNote: {
    defaultMessage: 'Note: Plans are subject to applicable taxes, if any.',
    description: 'Disclaimer note about taxes that may apply to plans',
    id: 'A90Tp0',
  },
  contactCustomerSupportButtonText: {
    defaultMessage: 'Contact Customer Support',
    description: 'Button text shown instead of Update Plan when annual user attempts to switch to monthly billing',
    id: 'egkwEs',
  },
  removeAddOn: {
    defaultMessage: 'Remove',
    description: 'Link text to remove an add-on from the plan in the plan summary',
    id: 'xiEbnW',
  },
  addAddOn: {
    defaultMessage: 'Add',
    description: 'Link text to re-add a removed add-on in the plan summary',
    id: '5hdzNf',
  },
  downgradeAddOnWarning: {
    defaultMessage:
      'If you downgrade to a lower plan, any Add-Ons included in your current plan will be billed at full price unless removed.',
    description: 'Warning banner shown when downgrading to a plan that converts included add-ons to paid',
    id: 'chTGWh',
  },
});
